import InfoCardMessage from 'components/atoms/InfoCardMessage';
import React from 'react';
import { IErrorBondaryProps, IErrorBondaryState } from './types';

class ErrorBoundary extends React.Component<
  IErrorBondaryProps,
  IErrorBondaryState
> {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
    };
  }

  componentDidCatch(error: Error): void {
    this.setState({ error });
  }

  render(): React.ReactNode {
    const { error } = this.state;

    if (error) {
      const { name, message } = error;
      return (
        <InfoCardMessage
          type="ERROR"
          title="Algo não deu certo"
          subtitle="Tente recarregar a página novamente"
          text="Se o problema persistir, entre em contato com o suporte e forneça os detalhes abaixo."
          messages={[JSON.stringify({ [name]: message }, null, 2)]}
        />
      );
    }

    const { children } = this.props;

    return <>{children}</>;
  }
}

export default ErrorBoundary;
